<template>
  <div>
    <ReportMember />
  </div>
</template>

<script>
import ReportMember from "@/components/reports/member.vue";

export default {
  components: {
    ReportMember
  }
};
</script>
